import { ConfirmationModalComponent } from '@app/core/components/modal/confirmation-modal/confirmation-modal.component';
import { ConfirmationModalWithReasonComponent } from '@app/core/components/modal/confirmation-modal-with-reason/confirmation-modal-with-reason.component';
import { ModalMessageInfo, ModalProps } from '@app/core/components/modal/modal-props';
import { CloseModal, OpenModal } from '@app/core/pcs-modal';
import { ComponentStyle } from '@app/shared/components/helpers/component-style';
import { hasValue, toArray } from '@app/util';
import { Action } from '@ngrx/store';
import { addCorrelationId } from '@util/correlation-id-helper';
import * as R from 'ramda';

const openModal = (props: ModalProps) => new OpenModal({
  component: ConfirmationModalComponent,
  props
});

const openModalWithReason = (props: ModalProps) => new OpenModal({
  component: ConfirmationModalWithReasonComponent,
  props
});

const getCancelActions = (actions: Action[] = []) => hasValue(actions)
  ? R.append(new CloseModal(), actions)
  : toArray(new CloseModal());

export const confirmPositive = (messageInfo: ModalMessageInfo, confirmActions: Action | Action[], cancelActions: Action[] = []) => openModal({
  componentStyle: ComponentStyle.Primary,
  messageInfo,
  confirmActions: toArray(confirmActions),
  customCancelActions: getCancelActions(cancelActions)
});

export const confirmNegative = (messageInfo: ModalMessageInfo, confirmActions: Action | Action[], cancelActions: Action[] = []) => openModal({
  componentStyle: ComponentStyle.Danger,
  messageInfo,
  confirmActions: toArray(confirmActions),
  customCancelActions: getCancelActions(cancelActions)
});

export const confirmWithReason = (messageInfo: ModalMessageInfo, confirmActions: Action | Action[] = [], cancelActions: Action[] = []): OpenModal => openModalWithReason({
  componentStyle: ComponentStyle.Primary,
  messageInfo,
  confirmActions: addCorrelationId(toArray(confirmActions)),
  customCancelActions: getCancelActions(cancelActions)
});

export const confirmWithWarningMessage = (message: string, confirmActions: Action[]) => confirmNegative({
  titleText: 'general.label.warning',
  buttonText: 'general.action.confirm',
  message
}, confirmActions);
